export default "__VITE_ASSET__CxmqM9Ay__"